/*
Gets the group by parameters that have been saved on the local storage.
*/
const parseStoredGroupBy = storedGroupBy => {
    if (!storedGroupBy) return {};
    const groupByArray =
        typeof storedGroupBy === 'string'
            ? storedGroupBy.split(',')
            : storedGroupBy;
    const obj = groupByArray.reduce((acc, name) => {
        acc[name] = !!name;
        return acc;
    }, {});

    return obj;
};

export default parseStoredGroupBy;
